export default "/build/images/jcb.23c6093d.png";